import { API_ENDPOINTS } from "@iso/constants/apiEndpoints.constant";
import BaseService from "./base.service";

export default class apiOptionValuesService extends BaseService {
  getDataOptionWithCondition = (values) => {
    return this.axios.post(API_ENDPOINTS.GET_API_OPTION_VALUES, values);
  };

}